import { render, staticRenderFns } from "./ModalCupon.vue?vue&type=template&id=8313efd2"
import script from "./ModalCupon.vue?vue&type=script&lang=js"
export * from "./ModalCupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8313efd2')) {
      api.createRecord('8313efd2', component.options)
    } else {
      api.reload('8313efd2', component.options)
    }
    module.hot.accept("./ModalCupon.vue?vue&type=template&id=8313efd2", function () {
      api.rerender('8313efd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/settings/modales/ModalCupon.vue"
export default component.exports